export default "__VITE_ASSET__OAJrmYxj__"